
import { BaseClass } from '../base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { User } from '../user/user';
import { Client } from '../client';

export class Vehicle extends BaseClass implements BaseRepository {
  numberplate: string;
  client: Client;
  user: User;
  comment?: string;
  // isMworker?: boolean;
  activeSurvey: boolean;
  mileage: number;

  constructor()
  constructor(
    numberplate: String, user: User, client: Client, comment: string, mileage?: number, activeSurvey?: boolean, isMworker?: boolean)
  constructor(
    numberplate?: string, user?: User, client?: Client, comment?: string, mileage?: number, activeSurvey?: boolean, isMworker?: boolean) {
    super();

    this.numberplate = this.trim(numberplate);
    this.user = user;
    this.client = client;
    this.comment = comment;
    this.mileage = mileage;
    this.activeSurvey = activeSurvey;
    // this.isMworker = isMworker;
  }

  static fromObject(object: Vehicle): Vehicle {
    return Object.assign(new Vehicle(), {
      ...object,
      client: object.client ? Client.fromObject(object.client) : null,
      user: object.user ? User.fromObject(object.user) : null
    });
  }

  get display(): string {
    return `${this.numberplate}`;
  }

  doesInclude(value: string): boolean {
    return this.some([this.numberplate], value);
  }
}
